module.exports = __webpack_public_path__ + "static/media/53.26ba586f.jpg";